import { render, staticRenderFns } from "./mzMaterialDetail.vue?vue&type=template&id=018e5ab6&scoped=true"
import script from "./mzMaterialDetail.vue?vue&type=script&lang=js"
export * from "./mzMaterialDetail.vue?vue&type=script&lang=js"
import style0 from "./mzMaterialDetail.vue?vue&type=style&index=0&id=018e5ab6&prod&scoped=true&lang=css"
import style1 from "./mzMaterialDetail.vue?vue&type=style&index=1&id=018e5ab6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018e5ab6",
  null
  
)

export default component.exports